module.exports = __webpack_public_path__ + "static/img/1.a5bf4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lamikal/1.jpg
// module id = WEpu
// module chunks = 0